"use client"

import Link from 'next/link'
import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import type { MobileNavigationSection } from '@/lib/mcare-data'
import { HeaderAuthActions } from '@/components/HeaderAuthActions'

export function MobileDrawer({ sections }: { sections: MobileNavigationSection[] }) {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : ''
    return () => { document.body.style.overflow = '' }
  }, [open])

  return <div className="lg:hidden">
    <button
      type="button"
      className="inline-flex h-12 w-12 items-center justify-center rounded-lg border border-[#3A3A3A] bg-[#2A2A2A] text-[#F9FAFB] shadow-lg shadow-[#111827]/5"
      aria-label={open ? '모바일 메뉴 닫기' : '모바일 메뉴 열기'}
      aria-expanded={open}
      aria-controls="mobile-navigation-drawer"
      onClick={() => setOpen(true)}
    >
      <span className="grid gap-1.5" aria-hidden="true"><i className="block h-0.5 w-5 rounded-full bg-current" /><i className="block h-0.5 w-5 rounded-full bg-current" /><i className="block h-0.5 w-5 rounded-full bg-current" /></span>
    </button>
    {open ? createPortal(<div className="fixed inset-0 z-[999]" role="dialog" aria-modal="true" aria-label="모바일 전체 메뉴">
      <button type="button" className="absolute inset-0 bg-[#F9FAFB]/45 backdrop-blur-sm" aria-label="모바일 메뉴 닫기" onClick={() => setOpen(false)} />
      <aside id="mobile-navigation-drawer" className="absolute right-0 top-0 h-dvh w-[min(88vw,390px)] overflow-y-auto rounded-l-lg bg-[#1A1A1A] px-8 py-7 shadow-2xl shadow-black/20">
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="text-sm font-black uppercase tracking-[0.2em] text-[#FF4500]">Music Care Lab</p>
          </div>
          <button type="button" className="rounded-full bg-[#2A2A2A] px-4 py-2 text-sm font-black text-[#F9FAFB]" onClick={() => setOpen(false)}>닫기</button>
        </div>
        <div className="mt-7 grid gap-5">
          {sections.map((section) => <section key={section.title}>
            <h3 className="text-sm font-black tracking-[-0.02em] text-[#FF4500]">{section.title}</h3>
            <div className="mt-2 grid gap-1.5">
              {section.items.map((item) => <Link key={`${section.title}-${item.href}`} href={item.href} onClick={() => setOpen(false)} className="py-1 pl-3 text-base font-black leading-7 tracking-[-0.03em] text-[#F3F4F6] transition hover:text-[#FF4500]">{item.label}</Link>)}
            </div>
          </section>)}
        </div>
        <HeaderAuthActions mobile onNavigate={() => setOpen(false)} />
        <Link href="/contact" onClick={() => setOpen(false)} className="mt-7 flex justify-center rounded-full bg-[#FF4500] px-5 py-4 font-black text-white shadow-xl shadow-[#FF4500]/20">상담 문의하기</Link>
      </aside>
    </div>, document.body) : null}
  </div>
}
